import { formatCelular, formatCnpj } from "./inputMasks";

function getSurveyApiConfig() {
  const baseUrl = process.env.REACT_APP_SURVEY_API_URL?.trim() || "";
  const apiKey = process.env.REACT_APP_SURVEY_API_KEY?.trim();

  if (!apiKey) {
    throw new Error("Configuração da API de diagnóstico não encontrada.");
  }

  return {
    baseUrl: baseUrl.replace(/\/$/, ""),
    apiKey,
  };
}

async function parseErrorResponse(response) {
  const data = await response.json().catch(() => ({}));
  const detail =
    typeof data.detail === "string"
      ? data.detail
      : typeof data.message === "string"
        ? data.message
        : null;

  if (response.status === 404) {
    throw new Error("Não existe diagnostico registrado");
  }

  throw new Error(
    detail || `Não foi possível carregar o diagnóstico (${response.status}).`
  );
}

export async function fetchReport(code) {
  if (!code) {
    return null;
  }

  const { baseUrl, apiKey } = getSurveyApiConfig();
  const url = `${baseUrl}/survey?code=${encodeURIComponent(code)}`;

  const response = await fetch(url, {
    headers: {
      "X-API-Key": apiKey,
    },
  });

  if (!response.ok) {
    await parseErrorResponse(response);
  }

  const data = await response.json();

  if (data.status_code && data.status_code !== 200) {
    throw new Error("Não existe diagnostico registrado");
  }

  return { ...data, code };
}

const UPDATE_ERROR_MESSAGE = "Não conseguimos atualizar, tente novamente";

export async function updateSurvey({ code, cnpj, celular }) {
  const { baseUrl, apiKey } = getSurveyApiConfig();
  const url = `${baseUrl}/survey`;

  const payload = {
    code,
    cnpj: formatCnpj(cnpj),
    celular: formatCelular(celular),
  };

  const response = await fetch(url, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      "X-API-Key": apiKey,
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error(UPDATE_ERROR_MESSAGE);
  }

  const data = await response.json();

  if (data.status_code && data.status_code !== 200) {
    throw new Error(UPDATE_ERROR_MESSAGE);
  }

  return data;
}
